export const data = {
  DEPLOYMENT_ENV: 'production',
  NEXT_PUBLIC_GTM_ID: "GTM-TPFGGLT",
  NEXT_PUBLIC_SITE_MACHINE_NAME: 'ops',
  NEXT_PUBLIC_CF_RC_SPACE_ID: 'jnzexz4x7lkk',
  NEXT_PUBLIC_CF_RC_ENVIRONMENT: 'master',
  NEXT_PUBLIC_RC_TYPE: 'resources',
  NEXT_PUBLIC_RENDER_NAV: true,
  NEXT_PUBLIC_RENDER_FOOTER: true,
  NEXT_PUBLIC_PRERENDER_ARTICLES: true,
  NEXT_PUBLIC_PRERENDER_CASESTUDIES: true,
  NEXT_PUBLIC_PRERENDER_DOCS: true,
  NEXT_PUBLIC_PRERENDER_VIDEOS: true,
  NEXT_PUBLIC_DATA_REVALIDATION: false,
  NEXT_PUBLIC_DATA_REVALIDATION_SECONDS: 0,
  NEXT_PUBLIC_PREVIEW_DATA: false,
  NEXT_PUBLIC_GTM_DISABLE: false,
  NEXT_PUBLIC_ONETRUST_DISABLE: false,
  NEXT_PUBLIC_ONETRUST_ID: "f5c9e4da-750d-4ac0-8c59-c499cf1e3f8e",
  NEXT_PUBLIC_ALGOLIA_APP_ID: "BGUNL6UMZR",
  NEXT_PUBLIC_ALGOLIA_SITE_INDEX: "trimble-rc-ops",
  NEXT_PUBLIC_ALGOLIA_API_KEY: "d391b07b54d358a1351edb9a348b4a75",
  NEXT_PUBLIC_ALGOLIA_SEARCH_HITS_PER_PAGE: 10,
  BASE_URL: 'https://assetlifecycle.trimble.com/resources',
  // BASE_URL: 'https://trimble-rc-ops-resources.netlify.app',
  // CONFIG_BASE_URL: '/opsR',
  NAV_BASE_URL: 'https://assetlifecycle.trimble.com',
  SHOW_UNPUBLISHED_NAV: false,
  SECURE_SITE: false,
  SECURE_SITE_PASS: "trimble",
  SECURE_SITE_PASS_HASH: "wuv6zfn0BDU!aty0fyx"
}
